import React from 'react';
import {
  Box, createStyles, Text, Title,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import {
  IconSquareRotated,
} from '@tabler/icons';

const useStyles = createStyles((theme) => ({
  generalBox: {
    marginBlock: theme.spacing.sm,
  },
}));

interface ProjectsProps {
    i18nKey: string,
    [x: string]: any;
}

export default function Projects({
  i18nKey,
  ...props
}: ProjectsProps) {
  const { theme } = useStyles();
  const { t } = useTranslation('translation', {
    keyPrefix: i18nKey,
  });
  const items = t('items', {
    returnObjects: true,
    defaultValue: [],
  }) as { title: string, description: string, paragraphs: string[] }[];

  return (
    <Box {...props} sx={{ marginBottom: theme.spacing.md }}>
      <Title
        order={4}
        align="center"
        sx={{ padding: 0, marginBottom: theme.spacing.sm }}
      >
        {t('title')}
      </Title>
      <Box className="border-gradient" sx={{ paddingBlock: theme.spacing.sm }}>
        {items?.map((item) => (
          <Box sx={{ paddingBottom: theme.spacing.sm }}>
            {!!item.title && <Text size="md" weight="bold">{item.title}</Text>}
            <Text size="sm" sx={{ paddingBottom: theme.spacing.xs }}>{item.description}</Text>
            {item.paragraphs?.map((bullet) => (
              <Box sx={{ display: 'inline-list-item' }}>
                <IconSquareRotated size={13} style={{ color: 'var(--accent-color-dark)', marginRight: 5 }} />
                <Text size="sm">{bullet}</Text>
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
